import './course-live-skeleton.css';

const Bone = ({ className = '' }) => (
    <span className={`cls-bone ${className}`.trim()} aria-hidden="true" />
);

const SIDEBAR_TABS = ['Clases', 'Tareas', 'Recursos', 'Avisos', 'Participantes'];

const ChatMessagesBones = () => (
  <>
    <Bone className="cls-bone--bubble is-left" />
    <Bone className="cls-bone--bubble is-right" />
    <Bone className="cls-bone--bubble is-left-short" />
    <Bone className="cls-bone--bubble is-right-short" />
    <Bone className="cls-bone--bubble is-left" />
  </>
);

const ClassSlotBones = () => (
  <>
    {[0, 1, 2].map((index) => (
      <div key={index} className="course-live-skeleton__slot-card">
        <div className="course-live-skeleton__slot-head">
          <div className="cls-bone--slot-meta">
            <Bone className="cls-bone--day" />
            <Bone className="cls-bone--time" />
          </div>
          <Bone className="cls-bone--chip" />
        </div>
        <div className="course-live-skeleton__slot-actions">
          <Bone className="cls-bone--action" />
        </div>
      </div>
    ))}
  </>
);

/** Placeholder del layout del curso mientras carga el chat y datos iniciales. */
export const CourseLiveSkeleton = () => (
  <div
    className="course-live-skeleton course-live-shell"
    role="status"
    aria-busy="true"
    aria-label="Cargando curso"
  >
    <span className="sr-only">Cargando curso…</span>

    <div className="course-live-skeleton__main">
      <header className="course-live-skeleton__chat-header">
        <div className="course-live-skeleton__chat-title-wrap">
          <Bone className="cls-bone--flag" />
          <Bone className="cls-bone--title" />
        </div>
        <Bone className="cls-bone--status" />
      </header>

      <div className="course-live-skeleton__messages">
        <ChatMessagesBones />
      </div>

      <div className="course-live-skeleton__input">
        <Bone className="cls-bone--input" />
        <Bone className="cls-bone--send" />
      </div>
    </div>

    <aside className="course-live-skeleton__sidebar" aria-hidden="true">
      <div className="course-live-skeleton__tabs">
        {SIDEBAR_TABS.map((label, index) => (
          <div
            key={label}
            className={`course-live-skeleton__tab${index === 0 ? ' course-live-skeleton__tab--active' : ''}`}
          >
            <Bone className="cls-bone--tab" />
          </div>
        ))}
      </div>

      <div className="course-live-skeleton__panel">
        <ClassSlotBones />
      </div>
    </aside>
  </div>
);
